import api from "./api";

export const CadastrarCategoria = async (data) => {
  try {
    const categorias = await api.post(`/categorias`, data);
    return categorias.data;
  } catch (error) {
    throw error;
  }
};

export const EditarCategoria = async (data, id) => {
  try {
    const categorias = await api.put(`/categorias/${id}`, data);
    return categorias.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarCategoria = async (id) => {
  try {
    const categorias = await api.put(`/categorias/${id}`, { ativo: false });
    return categorias.data;
  } catch (error) {
    throw error;
  }
};
